// Chakra imports
import { Box, Flex, SimpleGrid } from '@chakra-ui/react';
// Assets
import banner from 'assets/img/auth/banner.png';
import profile from 'assets/img/avatars/pro.png';
// Custom components
import Info from './components/Info';
import Password from './components/Password';
import Profile from './components/Profile';

import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getCreator } from 'utils/creator/creator';

export default function Settings() {
  const [creator, setCreator] = useState<any>();
  const [funk, setFunk] = useState();
  const storage = JSON.parse(localStorage.getItem('user'));
  const Creator = async (id: string) => {
    const result = await getCreator(id);
    if (result?.status !== 'Success') return false;
    setCreator(result?.data);
    setFunk(result?.data);
  };
  useEffect(() => {
    Creator(storage.data.id);
  }, []);
  return (
    <Box pt={{ base: '75px', md: '80px', xl: '80px' }}>
      <SimpleGrid
        mb="20px"
        columns={{ sm: 1, lg: 2 }}
        spacing={{ base: '20px', xl: '20px' }}
      >
        <Flex direction="column">
          <Profile
            name="Vlad Mihalache"
            data={creator}
            avatar={profile}
            banner={banner}
          />
          <Info funk={funk} setFunk={setFunk} />
        </Flex>

        <Flex direction="column">
          <Password />
        </Flex>
      </SimpleGrid>
    </Box>
  );
}
